import React from 'react';
import { render } from 'react-dom';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { selectYourXDropdownToggle } from '../actions/selectYourXDropdownsActions';
import { brandSelected } from '../actions/brandActions';
import { dropdownIndex } from '../actions/selectYourXIndexActions';
import { withRouter } from 'react-router';


class BrandAlphaCardLink extends React.Component {
    constructor() {
        super();
        this.onClick = this.onClick.bind(this);
    }
    onClick(brandId) {
        this.props.selectYourXDropdownToggle(dropdownIndex.brand);
        this.props.brandSelected(brandId, this.props.finderTypeId);
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <li className="alpha-li">
                <Link to={{ pathname: '/' + encodeURIComponent(this.props.data), search: this.props.location.search }} onClick={() => this.onClick(this.props.data)}>{this.props.data}</Link>
            </li>
        );
    }
}
function mapStateToProps(state) {
    return {
        finderTypeId: state.finderTypeId
    };
}
function mapDispatchToProps(dispatch) {
    return {
        selectYourXDropdownToggle: (e) => dispatch(selectYourXDropdownToggle(e)),
        brandSelected: (e, finderType) => dispatch(brandSelected(e, finderType))

    };
}
export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(BrandAlphaCardLink));